import type React from 'react'
import type { PropsWithChildren } from 'react'

import { cn } from '@/utils/shadcn/utils'

export const DialogFooterContainer: React.FC<
  PropsWithChildren<{
    className?: string
  }>
> = ({ children, className }) => (
  <div className={cn('flex justify-end gap-2', className)}>{children}</div>
)

export const DialogContentContainer: React.FC<
  PropsWithChildren<{
    className?: string
  }>
> = ({ children, className }) => (
  <div className={cn('text-secondary', className)}>{children}</div>
)
